<template>
  <div class="columns is-multiline">
    <div class="column is-6">
      <div class="box">
        <admin-box-item title="내부 플러그인" subtitle="내부 플러그인을 등록, 수정을 할 수 있습니다.">
          <admin-form-item label="플러그인 key">
            <input class="input"
                   :value="value.key"
                   @input="e => value.key = e.target.value"
                   type="text">
          </admin-form-item>
          <admin-form-item label="플러그인 이름">
            <input class="input"
                   :value="value.name"
                   @input="e => value.name = e.target.value"
                   type="text">
          </admin-form-item>
          <admin-form-item label="플러그인 사용 구분">
            <lp-radio :val.sync="value.use_type"
                      value_name="value"
                      label_name="label"
                      style="margin-top:8px"
                      :data="[{label:'프론트+백오피스',value:0},{label:'백오피스',value:1},{label:'백오피스 패널',value:2}]"></lp-radio>
          </admin-form-item>
        </admin-box-item>
      </div>

      <!-- 저장하기 -->
      <div class="btn-group-justify-end">
        <button class="button is-primary" @click="saveData">저장하기</button>
      </div>
    </div>
  </div>
</template>

<script>
  import AdminFormItem from "../../../module/admin/AdminFormItem";
  import LpRadio from "../../../module/common/LpRadio";

  export default {
    components: {LpRadio, AdminFormItem},
    name: "internal-plugin-create",
    data () {
      return {
        value: {
          key: '',
          name: '',
          use_type: 0
        }
      }
    },
    created () {
      this.getData();
    },
    methods: {
      getData () {
        if(this.$route.query.id) {
          this.$axios.get(`admin/launchpack/internal_plugin/${this.$route.query.id}`).then(res => {
            this.value = res.data;
          })
        }
      },
      saveData () {
        let url = `admin/launchpack/internal_plugin`;
        if(this.$route.query.id) {
          url += `/${this.$route.query.id}`;
          this.$axios.patch(url, this.value).then(res => {
            if(res.status===200) {
              this.toast('저장되었습니다.');
              this.$router.replace(this.getPath('launchpack/internal_plugin'));
            }
          })
        }
        else {
          this.$axios.post(url, this.value).then(res => {
            if(res.status===200) {
              this.toast('저장되었습니다.');
              this.$router.replace(this.getPath('launchpack/internal_plugin'));
            }
          })
        }
      }
    }
  }
</script>

<style scoped>

</style>
